module.exports = __webpack_public_path__ + "static/media/statBackground.f8009388.png";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/statBackground.png
// module id = ./src/statsradio/assets/img/statBackground.png
// module chunks = 18